<template>
  <router-link :to="`/products/${id}`" class="col-md-6 mousa-link-block">
    <div class="d-flex mousa-item">
      <div class="mousa-image-div">
        <img :class="[{ 'image-large': imageLarge }]" :src="image" alt="" />
      </div>
      <div class="mousa-content">
        <h4 class="mousa-name">{{ name }}</h4>
        <h4 class="mousa-subtitle text-primary">{{ subtitle }}</h4>
        <p class="mouse-description">{{ description }}</p>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "ProductListItem",
  props: ["name", "subtitle", "description", "image", "id", "imageLarge"],
};
</script>
<style lang="scss" scoped>
.mousa-link-block:hover {
  opacity: 0.7;
}
.mousa-item {
  margin-bottom: 24px;
}
.mousa-image-div {
  min-width: 100px;
  width: 200px;
  height: 200px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  img {
    height: 50%;
    display: block;
    &.image-large {
      height: 75%;
    }
  }
}
.mousa-content {
  display: flex;
  padding-left: 15px;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}
.mousa-name {
  font-size: 16px;
  margin-bottom: 10px;
}
.mousa-subtitle {
  font-size: 14px;
  margin-bottom: 10px;
}
.mouse-description {
  font-size: 14px;
}
@media (max-width: 767px) {
  .mousa-image-div {
    width: 125px;
    height: 125px;
  }
}
</style>